import Joi from 'joi';
import { Form, json, useActionData, redirect } from 'react-router-dom';
import { fetchClient } from '../../util/fetchClient';
import logo from '../../logo.svg';

const signUpSchema = Joi.object({
  company_name: Joi.string().required(),
  first_name: Joi.string().required(),
  last_name: Joi.string().required(),
  phone: Joi.string().optional().allow(null),
  email: Joi.string().email({ tlds: { allow: false } }).required(),
  password: Joi.string().required(),
}).options({ abortEarly: false });

const errorDetailsByKey = errorDetails => {
  const errors = {} ;

  if (!errorDetails) {
    return errors;
  }

  errorDetails.map((details) => errors[details.context.key] = details.message);

  return errors;
};

export const action = async ({ request }) => {
  const data = Object.fromEntries(await request.formData());

  try {
    await signUpSchema.validateAsync(data);
  } catch (validationError) {
    const errors = errorDetailsByKey(validationError?.details);

    validationError?.details.map((details) => errors[details.context.key] = details.message);
    console.error(errors);

    return json({ errors });
  }

  const response = await fetchClient('/v1/auth/signup', { method: 'POST', body: JSON.stringify(data) });
  if (response.response.ok) {
    return redirect('/signup/success');
  } else {
    const errors = await response.response.json();
    console.error(errors);
    return json({ errors: errorDetailsByKey(errors.error_details) });
  }
};

export default function Signup() {
  const actionData = useActionData();

  return (
    <>
      <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-sm space-y-6">
          <div>
            <img
              className="mx-auto h-16 w-auto"
              src={logo}
              alt="RÖEN"
            />
            <h2 className="mt-4 text-center text-4xl font-bold leading-9 tracking-tight text-gray-900">
              Creación de cuenta
            </h2>

            <div className="pt-3 flex items-center justify-center">
              <div className="flex items-center">
                <p className="text-sm leading-6 text-gray-500 text-center">
                  Por favor ingresa tus datos para crear tu cuenta. No tiene costo y no requiere introducir tu tarjeta!
                </p>
              </div>
            </div>
          </div>

          <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-sm">
            <Form method="post" className="space-y-7">
              <div className='sm:grid sm:grid-cols-3 sm:items-start'>
                <label htmlFor="company_name" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  Compañía
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    id="company_name"
                    name="company_name"
                    type="text"
                    autoComplete="company_name"
                    className={
                      actionData?.errors?.company_name
                        ? "block w-full rounded-md border-1 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-rose-500 placeholder:text-rose-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6"
                        : "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    }
                  />
                </div>
              </div>

              <div className='sm:grid sm:grid-cols-3 sm:items-start'>
                <label htmlFor="first_name" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  Nombre(s)
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    id="first_name"
                    name="first_name"
                    type="text"
                    autoComplete="first_name"
                    className={
                      actionData?.errors?.first_name
                        ? "block w-full rounded-md border-1 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-rose-500 placeholder:text-rose-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6"
                        : "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    }
                  />
                </div>
              </div>

              <div className='sm:grid sm:grid-cols-3 sm:items-start'>
                <label htmlFor="last_name" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  Apellido(s)
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    id="last_name"
                    name="last_name"
                    type="text"
                    autoComplete="last_name"
                    className={
                      actionData?.errors?.last_name
                        ? "block w-full rounded-md border-1 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-rose-500 placeholder:text-rose-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6"
                        : "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    }
                  />
                </div>
              </div>

              <div className='sm:grid sm:grid-cols-3 sm:items-start'>
                <label htmlFor="phone" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  Teléfono
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    id="phone"
                    name="phone"
                    type="text"
                    autoComplete="phone"
                    className={
                      actionData?.errors?.phone
                        ? "block w-full rounded-md border-1 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-rose-500 placeholder:text-rose-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6"
                        : "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    }
                  />
                </div>
              </div>

              <div className='sm:grid sm:grid-cols-3 sm:items-start'>
                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  Email
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    id="email"
                    name="email"
                    type="text"
                    autoComplete="email"
                    className={
                      actionData?.errors?.email
                        ? "block w-full rounded-md border-1 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-rose-500 placeholder:text-rose-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6"
                        : "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    }
                  />
                </div>
              </div>

              <div className='sm:grid sm:grid-cols-3 sm:items-start'>
                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  Contraseña
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="password"
                    className={
                      actionData?.errors?.password
                        ? "block w-full rounded-md border-1 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-rose-500 placeholder:text-rose-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6"
                        : "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    }
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Crear cuenta
                </button>
              </div>
            </Form>

            <p className="mt-5 text-center text-sm text-gray-500">
              ¿Tienes preguntas? <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send/?phone=5213334523607&text&type=phone_number&app_absent=0" className="font-semibold text-indigo-600 hover:text-indigo-500">Contáctanos</a>.
            </p>
            <p className="mt-3 text-center text-sm text-gray-500">
              ¿Ya tienes una cuenta? <a href="/" className="font-semibold text-indigo-600 hover:text-indigo-500">Inicia sesión</a>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
